import { AfterViewInit, ChangeDetectorRef, Component, effect, Input, OnInit } from '@angular/core';
import { ViewChild, ElementRef } from '@angular/core';
import { PatientSessionService } from '../patient-session.service';
import { AlarmOption, PatientTargetDataModel, PatientTargetModel, PatientTargetStatus } from '../../../core/api/models';
import { BaseBoxComponent } from '../base-box/base-box.component';
import { AlertService } from '../../../shared/services/alert.service';
@Component({
  selector: 'app-box-interval',
  templateUrl: './box-interval.component.html',
  standalone: false,
})
export class BoxIntervalComponent extends BaseBoxComponent implements AfterViewInit, OnInit {
  text: string | undefined = '-';
   expectedAmount: number = 0;
  @Input() isTopBox: boolean = true;
  @Input() isBottomBox: boolean = false;
  @Input() target: PatientTargetModel | undefined = undefined;
  @Input() isPreview?: boolean;
  timerInitialValue: number = 60;
  targetID: number = 0;
  targetData: PatientTargetDataModel[] = [];

  isStarted: boolean = false;
  timerValue: number = 0;
  private startTime: number = 0;
  intervals: { happened: boolean; RecordedDate: string; FormattedDate: string;}[] = [];  
  happened: boolean = false;

  timeOut: any;
  remainingTrials: number = 0;
  constructor(
    protected override cdRef: ChangeDetectorRef,
    private patientSessionService: PatientSessionService,
    private alertService: AlertService
  ) {
    super(cdRef);
    effect(() => {
      this.patientSessionService.dataChanged();
      const targetData = this.patientSessionService.getTargetData(this.targetID);
      if (targetData) {
        this.targetData = targetData.filter(t => !t.DeletedDate);
        
        this.remainingTrials = (this.target?.DesiredTrials ?? 0) - this.targetData.length;
        if (this.remainingTrials < 0) {
          this.remainingTrials = 0;
        }

        if (this.target?.TargetStatus === PatientTargetStatus.Mastered || this.target?.TargetStatus === PatientTargetStatus.Closed || this.target?.TargetStatus === PatientTargetStatus.Fluent) {
          this.remainingTrials = 0;
        }
        this.intervals = this.targetData.map(t => {
          if (!t.TextValue) {
            t.TextValue = '';
          }
          //parse the totalCorrect and totalIncorrect from the textvalue
          this.happened = (t.IntValue ?? 0) > 0;
          return {
            happened: this.happened,
            RecordedDate: t.RecordedDate ?? '',
            FormattedDate: this.formatDate(new Date(t.RecordedDate ?? '')),
          };

        });

      }
      else {
        this.targetData = [];
        this.intervals = [];
      }
    });

    effect(() => {
      this.patientSessionService.dataChanged();
      const targetsRunningData = this.patientSessionService.getTargetsRunningData(this.patientSessionService.getPatientSession()?.ID ?? -1,this.targetID);
      if (targetsRunningData) {
        const wasStarted = this.isStarted;
        this.isStarted = targetsRunningData.Data.isStarted;
        this.startTime = targetsRunningData.Data.startTime;
        this.timerValue = this.isStarted
          ? this.getCurrentTimerValue()
          : targetsRunningData.Data.timerValue;
        this.happened = (targetsRunningData.Data.happened ?? false);
        if (this.isStarted && !wasStarted) {
          if (this.timeOut) {
            clearTimeout(this.timeOut);
          }
          this.timeOut = setTimeout(() => {
            this.updateTimer();
          }, 10);
        }
      } else {
        this.isStarted = false;
        this.startTime = 0;
        this.timerValue = this.timerInitialValue;
        this.happened = false;
      }
    });
  }

  ngOnInit() {
    this.text = this.target?.TargetName ?? '-';
    this.targetID = this.target?.ID ?? 0;
    this.expectedAmount = this.target?.DesiredTrials ?? 1;
    this.timerInitialValue = this.target?.Duration ?? 60;
    this.timerValue = this.timerInitialValue;
  }

  override doLongPress(): void {
    this.showExtra2();
  }

  startTimer() {
    if (this.isStarted) {
      this.showExtra();
    } else {
      this.isStarted = true;
      this.startTime = Date.now();
      this.happened = false;
      this.updateTimer();
      this.saveTargetRunningData();
    }
  }


  saveTargetRunningData() {
    this.patientSessionService.setTargetsRunningData(this.patientSessionService.getPatientSession()?.ID ?? -1, this.targetID, { isIntervalTarget:true, isStarted: this.isStarted, startTime: this.startTime, timerValue: this.timerValue, happened: this.happened });
  }

  private updateTimer(): void {
    if (this.isStarted) {
      this.timerValue = this.getCurrentTimerValue();
      
      const shouldRingAlarm = this.timerValue === 0 && 
        (this.target?.AlarmOption === AlarmOption.AlarmAtEnd);
      
      this.ringAlarmIfNeeded(
        this.target?.AlarmOption ?? AlarmOption.NoAlarm, 
        this.timerValue, 
        this.target?.Duration ?? 0, 
        this.target?.AlarmSoundOption ?? 1,
        false
      );

      if (this.timerValue <= 0) {
        // If alarm should ring, delay the stop to allow alarm to play
        if (shouldRingAlarm) {
          setTimeout(() => {
            this.stopTimer();
          }, 100);
        } else {
          this.stopTimer();
        }
      } else {
        if (this.timeOut) {
          clearTimeout(this.timeOut);
        }
        this.timeOut = setTimeout(() => {
          this.updateTimer();
        }, 1000);
      }
    }else {
      if (this.timeOut) {
        clearTimeout(this.timeOut);
      }
    }
  }

  private getCurrentTimerValue(): number {
    return Math.max(
      0,
      this.timerInitialValue - Math.floor((Date.now() - this.startTime) / 1000)
    );
  }

  override ngOnDestroy() {
    if (this.timeOut) {
      clearTimeout(this.timeOut);
    }
    super.ngOnDestroy();
  }

  stopTimer(force: boolean = false) {
    if (this.timeOut) {
      clearTimeout(this.timeOut);
    }
    this.isStarted = false;
    const currentDate = new Date();
    const formattedDate = this.formatDate(currentDate);
    this.patientSessionService.addTargetData({
      IntValue: this.happened ? 1 : 0,
      TextValue: this.happened ? '1' : '0',
      PatientTargetID: this.targetID,
      RecordedDate: currentDate.toServerString(),
    });
    
      
    this.timerValue = this.timerInitialValue;
    this.happened = false;
    this.startTime = Date.now();

    this.saveTargetRunningData();
    this.closeExtra();
    if(!force){
      this.startTimer();
    }
  }

  timerString() {
    const minutes = Math.floor(this.timerValue / 60);
    const seconds = this.timerValue % 60;
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }

  lastInterval() {
    if (this.intervals.length > 0) {
      const lastInterval = this.intervals[this.intervals.length - 1];
      return `${lastInterval.happened ? 'Happened' : 'Didn´t happened'}`;
    } else {
      return '';
    }
  }

  setHappened(event: any) {
    this.happened = event.checked;
    this.saveTargetRunningData();
  }

  deleteData(data: any) {
    //confirm the deletion
    const confirmed = this.alertService.confirm('Are you sure you want to delete this data?', 'Delete Data');
    confirmed.subscribe(result => {
      if (result) {
        let targetDataToSave: PatientTargetDataModel | undefined = this.targetData.find(t =>
          t.RecordedDate === data.RecordedDate
        );

        if (targetDataToSave) {
          targetDataToSave.DeletedDate = new Date().toServerString();
          this.patientSessionService.saveTargetData(targetDataToSave);
        }
      }
    });
  }
}
